export default {
  'Please select an output format': '請選擇一個輸出格式：',
}